import * as authoringHubBusiness from './hubs/authoringHubBusiness';
import * as labwareDefinitionHubBusiness from './hubs/labwareDefinitionHubBusiness';
import * as sessionHubBusiness from './hubs/sessionHubBusiness';
import * as userManagementHubBusiness from './hubs/userManagementHubBusiness';
import * as stateHubBusiness from './hubs/stateHubBusiness';
import * as instrumentHubBusiness from './hubs/instrumentHubBusiness';
import * as signalrStateAction from '../actions/signalrStateAction';
import * as softwareUpdaterHubBusiness from './hubs/softwareUpdaterHubBusiness';
import * as instrumentManagementBusiness from './hubs/instrumentManagementHubBusines';
import * as backupAndRestoreHubBusiness from './hubs/backupAndRestoreHubBusiness';
import {startSignalRHub} from './commonBusiness';

import {SignalRHub} from '../../constants/dataEnum';
import SignalRHubs from './hubs/SignalRHubs';

const buildHubObjectMap = () => async (dispatch) => {
  const hubObjectMap = {};

  try {
    const result = await Promise.all([
      dispatch(startSignalRHub(SignalRHub.AUTHORING)),
      dispatch(startSignalRHub(SignalRHub.LABWARE_DEFINITION)),
      dispatch(startSignalRHub(SignalRHub.TRAY)),
      dispatch(startSignalRHub(SignalRHub.USER_MANAGEMENT)),
      dispatch(startSignalRHub(SignalRHub.SESSION)),
      dispatch(startSignalRHub(SignalRHub.STATE)),
      dispatch(startSignalRHub(SignalRHub.PROTOCOL_MANAGEMENT)),
      dispatch(startSignalRHub(SignalRHub.INSTRUMENT_MANAGEMENT)),
    ]);
    [
      hubObjectMap[SignalRHub.AUTHORING],
      hubObjectMap[SignalRHub.LABWARE_DEFINITION],
      hubObjectMap[SignalRHub.TRAY],
      hubObjectMap[SignalRHub.USER_MANAGEMENT],
      hubObjectMap[SignalRHub.SESSION],
      hubObjectMap[SignalRHub.STATE],
      hubObjectMap[SignalRHub.PROTOCOL_MANAGEMENT],
      hubObjectMap[SignalRHub.INSTRUMENT_MANAGEMENT],
    ] = result;
  } catch (err) {
    console.error(err);

    return null;
  }

  return hubObjectMap;
};

export const buildMainHubs = () => async (dispatch) => {
  // start the hubs
  const hubObjectMap = await dispatch(buildHubObjectMap());

  if (!hubObjectMap) {
    return;
  }

  const buildKeyMap = {
    [SignalRHub.AUTHORING]: {
      subscribeMethod: authoringHubBusiness.subscribeEvent,
      signalrStateActionMethod: signalrStateAction.setAuthoringHubSignalR,
    },
    [SignalRHub.LABWARE_DEFINITION]: {
      subscribeMethod: labwareDefinitionHubBusiness.subscribeEvent,
      signalrStateActionMethod: signalrStateAction.setLabwareDefinitionHubSignalR,
    },
    [SignalRHub.TRAY]: {
      signalrStateActionMethod: signalrStateAction.setTrayHubSignalR,
    },
    [SignalRHub.USER_MANAGEMENT]: {
      subscribeMethod: userManagementHubBusiness.subscribeEvent,
      signalrStateActionMethod: signalrStateAction.setUserManagementHubSignalR,
    },
    [SignalRHub.SESSION]: {
      subscribeMethod: sessionHubBusiness.subscribeEvent,
      signalrStateActionMethod: signalrStateAction.setSessionHubSignalR,
    },
    [SignalRHub.STATE]: {
      subscribeMethod: stateHubBusiness.subscribeEvent,
      signalrStateActionMethod: signalrStateAction.setStateHubSignalR,
    },
    [SignalRHub.PROTOCOL_MANAGEMENT]: {
      signalrStateActionMethod: signalrStateAction.setProtocolManagementHubSignalR,
    },
    [SignalRHub.INSTRUMENT_MANAGEMENT]: {
      subscribeMethod: stateHubBusiness.subscribeEvent,
    },
  };

  Object.keys(buildKeyMap).forEach((e) => {
    const {subscribeMethod, signalrStateActionMethod} = buildKeyMap[e];
    const hubObj = hubObjectMap[e];

    if (hubObj) {
      if (subscribeMethod) {
        dispatch(subscribeMethod(hubObj));
      }

      if (signalrStateActionMethod) {
        dispatch(signalrStateActionMethod(hubObj));
      } else {
        dispatch(signalrStateAction.setHubSignalR(e, hubObj));
      }

      SignalRHubs.addHub(e, hubObj);
    }
  });
};

let retryBuildUpdaterHub = 0;
export const buildUpdaterHub = () => async (dispatch) => {
  // start the hubs
  const updaterHubObj = await dispatch(startSignalRHub(SignalRHub.SOFTWARE_UPDATER));

  if (!updaterHubObj && retryBuildUpdaterHub < 3) {
    dispatch(buildUpdaterHub());
    retryBuildUpdaterHub += 1;
    return;
  }

  if (updaterHubObj) {
    dispatch(softwareUpdaterHubBusiness.unsubscribeEvent(updaterHubObj));
    dispatch(softwareUpdaterHubBusiness.subscribeEvent(updaterHubObj));
    dispatch(signalrStateAction.setSoftwareUpdaterHubSignalR(updaterHubObj));
  }
};

let retryBuildBackupAndRestoreHub = 0;

export const buildBackupAndRestoreHub = () => async (dispatch) => {
  // start the hubs
  const backupAndRestoreHubObj = await dispatch(startSignalRHub(SignalRHub.BACKUP_AND_RESTORE));
  SignalRHubs.addHub(SignalRHub.BACKUP_AND_RESTORE, backupAndRestoreHubObj);

  if (!backupAndRestoreHubObj && retryBuildBackupAndRestoreHub < 3) {
    dispatch(buildBackupAndRestoreHub());
    retryBuildBackupAndRestoreHub += 1;

    return;
  }

  if (backupAndRestoreHubObj) {
    dispatch(backupAndRestoreHubBusiness.unsubscribeEvent(backupAndRestoreHubObj));
    dispatch(backupAndRestoreHubBusiness.subscribeEvent(backupAndRestoreHubObj));
    dispatch(signalrStateAction.setBackupAndRestoreHubSignalR(backupAndRestoreHubObj));
  }
};

let retryBuildInstrumentHub = 0;

export const buildInstrumentHub = () => async (dispatch) => {
  // start the hubs
  const instrumentHubObj = await dispatch(startSignalRHub(SignalRHub.INSTRUMENT));
  SignalRHubs.addHub(SignalRHub.INSTRUMENT, instrumentHubObj);

  if (!instrumentHubObj && retryBuildInstrumentHub < 3) {
    dispatch(buildInstrumentHub());
    retryBuildInstrumentHub += 1;
    return;
  }

  if (instrumentHubObj) {
    dispatch(instrumentHubBusiness.unsubscribeEvent(instrumentHubObj));
    dispatch(instrumentHubBusiness.subscribeEvent(instrumentHubObj));
    dispatch(signalrStateAction.setInstrumentHubSignalR(instrumentHubObj));
  }
};

const getHubBusiness = (hubName) => {
  let hubBusiness;

  switch (hubName) {
    case SignalRHub.INSTRUMENT:
      hubBusiness = instrumentHubBusiness;
      break;
    case SignalRHub.AUTHORING:
      hubBusiness = authoringHubBusiness;
      break;
    case SignalRHub.LABWARE_DEFINITION:
      hubBusiness = labwareDefinitionHubBusiness;
      break;
    case SignalRHub.SESSION:
      hubBusiness = sessionHubBusiness;
      break;
    case SignalRHub.STATE:
      hubBusiness = stateHubBusiness;
      break;
    case SignalRHub.SOFTWARE_UPDATER:
      hubBusiness = softwareUpdaterHubBusiness;
      break;
    case SignalRHub.INSTRUMENT_MANAGEMENT:
      hubBusiness = instrumentManagementBusiness;
      break;
    case SignalRHub.BACKUP_AND_RESTORE:
      hubBusiness = backupAndRestoreHubBusiness;
      break;
    default:
      break;
  }

  return hubBusiness;
};

export const destroySignalRHub = (hubName) => async (dispatch, getState) => {
  const {signalrState} = getState();
  const hub = signalrState[hubName];

  if (!hub) return;

  if (hub.connectionStarted) {
    hub.stop();
  }

  const hubBusiness = getHubBusiness(hubName);

  if (hubBusiness) {
    dispatch(signalrStateAction.setHubSignalR(hubName, null));
    if (hubBusiness.unsubscribeEvent) {
      dispatch(hubBusiness.unsubscribeEvent(hub));
    }
  }
};

export const buildSignalRHub = (hubName) => async (dispatch, getState) => {
  const {signalrState} = getState();
  const hub = signalrState[hubName];

  if (hub && hub.connectionState !== 'Connected') {
    hub.start();
    return hub;
  }

  await dispatch(destroySignalRHub(hubName));

  const hubBusiness = getHubBusiness(hubName);

  let result;

  if (hubBusiness) {
    try {
      result = await dispatch(startSignalRHub(hubName));
      dispatch(signalrStateAction.setHubSignalR(hubName, result));
      if (hubBusiness.subscribeEvent) {
        dispatch(hubBusiness.subscribeEvent(result));
      }
    } catch (e) {
      console.error('buildSignalRHub error', e);
    }
  }

  return result;
};
